import { render, staticRenderFns } from "./ContractLoanSummaryBeforeDiscount.vue?vue&type=template&id=c0e36660&"
import script from "./ContractLoanSummaryBeforeDiscount.vue?vue&type=script&lang=js&"
export * from "./ContractLoanSummaryBeforeDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports